/// <amd-module name="Widgets/AnalyticsSprintBurndown/AnalyticsSprintBurndownWidgetComponents/AnalyticsSprintBurndownSettings" />
import { AggregationSettings } from "Widgets/Burndown/BurndownWidgetComponents/BurndownSettings";

import { ITrackName } from "Dashboards/WidgetCommon/ITrackName";
import { TeamScope } from "WidgetCommon/ModernWidgetTypes/CommonConfigurationTypes";
import { ModefulValueSetting } from "WidgetCommon/ModernWidgetTypes/ModefulValueSetting";

export interface SprintBurndownTimePeriod {
    /** Describes a custom start date */
    startDate: string;

    /** Describes a custom end date */
    endDate: string;
}

export interface SprintBurndownToggleOptions {
    /** Describes if stack by Work item type option is enabled for rendering, to partition the total by work item type, vs a homogeneous total.*/
    stackByWorkItemTypeEnabled: boolean;

    /** Describes if the total scope trendline option is enabled for rendering. Inherited property, Disabled in Sprint Burndown widget.*/
    totalScopeTrendlineEnabled: boolean;

    /** Describes if the completed Work option is enabled for rendering. */
    completedWorkEnabled: boolean;

    /** Describes if work items with StateCategory/State == Resolved are considered as Completed */
    showResolvedItemsAsCompletedEnabled?: boolean;

    /** Indicates if non-working days are visible or not. Defaults to false.*/
    showNonWorkingDays?: boolean;

    /** Indicates if remaining capacity should be considered from start of the day*/
    showRemainingCapacityAtStartOfDay?: boolean;
}

export interface AnalyticsSprintBurndownSettings extends ITrackName, SprintBurndownToggleOptions {
    /**A singular team  */
    team: TeamScope;

    /** Describes the sprint being queried. This informs selection of the time period boundaries. */
    iterationId: string;
    /** Describes the data being queried via an implicit field filter condition. */
    iterationPath: string;

    /**
     * Describes the mode of aggregation.
     *  If mode is a sum based aggregation, the field identifies the field to aggregate on.
     */
    aggregation: AggregationSettings;

    /**
     * Describes the set of work item types to select. Uses WorkItemTypeFilterMode enum strings for identifiers.
     */
    workItemTypeFilter: ModefulValueSetting<string, string>;

    /** Contains configuration for time period options */
    timePeriodConfiguration: SprintBurndownTimePeriod;

    /** Flag to render minimal header chart */
    isMinimalChart?: boolean;

    /** Flag to render boards report lightbox chart */
    isLightboxChart?: boolean;

    /** Opt-out flag to ensure modern render behavior, used with upgraded legacy sprint burndown. Always false in this payload shape . */
    isLegacy?: false;

    /** Flag to know whether user has customized settings from default settings for widget */
    isCustomized?: boolean;
}
